<div class="flex justify-content-center p-0">
	<div class="p-col-12 p-md-6 p-lg-3 px-3 py-0">
		<div class="p-grid" id="location_info" align="center">
			<div class="p-col-12">
				<h3 class="first">
					{{ "h3.partSeparation" | translate }} {{ labelType }}
				</h3>
			</div>
		</div>
		<div class="pb-0">
			<label>{{ "h5.labelCode" | translate }}</label>
			<input
				type="number"
				(keydown.enter)="findByLabel()"
				[(ngModel)]="inputFields[0].value"
				min="1"
				minlength="1"
				maxlength="16"
				tabindex="-1"
				inputmode="number"
				pInputText
				aria-describedby="info-label"
				[ngClass]="{ focusField: inputFields[0].focus }"
				[id]="inputFields[0].id"
				(keydown)="onInsertUnit($event)"
			/>
		</div>
		<div class="pb-0">
			<label>{{ "h5.staging" | translate }}</label>
			<input
				type="text"
				min="1"
				minlength="1"
				maxlength="16"
				tabindex="-1"
				inputmode="text"
				pInputText
				aria-describedby="info-stage"
				[(ngModel)]="inputFields[1].value"
				(keydown.enter)="checkLocation()"
				[ngClass]="{ focusField: inputFields[1].focus }"
				[disabled]="inputFields[0].valid == false"
				(ngModelChange)="inputFields[1].valid = false"
				[id]="inputFields[1].id"
			/>
			<small id="info-stage" class="info">{{
				locationPartSelected
			}}</small>
		</div>
		<div class="pb-0">
			<label>{{ "h5.part" | translate }}</label>
			<input
				type="text"
				min="1"
				minlength="1"
				maxlength="21"
				tabindex="-1"
				inputmode="text"
				pInputText
				aria-describedby="info-partCode"
				[ngClass]="{ focusField: inputFields[2].focus }"
				[(ngModel)]="this.inputFields[2].value"
				(keydown.enter)="checkPart()"
				[disabled]="inputFields[0].valid == false"
				(ngModelChange)="this.inputFields[2].valid = false"
				[id]="inputFields[2].id"
			/>
			<small id="info-partCode" class="info">{{ partSelected }}</small>
		</div>
		<div
			*ngIf="areAllSerialNumbersFilled && shouldShowSerialNumberToEdit"
			class="edit-serial-number--container"
		>
			<label>{{ "label.serialNumbers" | translate }} </label>
			<div class="edit-serial-number--values">
				<div *ngFor="let serialNumber of serialNumbers">
					<label
						class="edit-serial-number--serial-number"
						(click)="shouldShowSerialNumberModal = true"
					>
						{{ serialNumber }}
						<i class="pi pi-pencil" style="margin-left: 8px"></i>
					</label>
				</div>
			</div>
		</div>
		<div class="pb-0">
			<label>{{ "h5.quantity" | translate }}</label>
			<input
				type="number"
				min="0"
				minlength="1"
				maxlength="16"
				tabindex="-1"
				inputmode="number"
				pInputText
				aria-describedby="info-qtd"
				[ngClass]="{ focusField: inputFields[3].focus }"
				[(ngModel)]="this.inputFields[3].value"
				(keyup)="checkQuantity()"
				(keydown.enter)="checkQuantity()"
				(blur)="checkQuantity()"
				[disabled]="inputFields[0].valid == false"
				(ngModelChange)="this.inputFields[3].valid = false"
				[id]="inputFields[3].id"
				(keydown)="checkValidCharacter($event)"
				(keydown)="onInsertUnit($event)"
			/>
			<small
				id="info-qtd"
				class="info"
				*ngIf="!isbulk && inputFields[0].valid == true"
				>{{ "label.multipleOf" | translate }} {{ multiple }}</small
			>
		</div>
		<hr style="border-top: 1px solid #cacaca; margin: 4px 0"/>

		<div class="button_container" *ngIf="!isAutomaticPickingHandHeldEnabled">
			<button
				class="submit"
				pButton
				type="submit"
				label="{{ 'button.save' | translate }}"
				[disabled]="checkInputs()"
				(click)="checkPickingSave()"
				[style]="{ width: '100%' }"
			></button>
		</div>

		<div class="last-picking-summary" *ngIf="isAutomaticPickingHandHeldEnabled && showLastPicking">
			<h4>{{ "summary.lastPicking" | translate }}</h4>
			<div class="last-picking-info">
				<div class="info-row">
					<label>{{ "h5.labelCode" | translate }}</label>
					<span>{{ lastPickedLabel }}</span>
				</div>
				<div class="info-row">
					<label>{{ "h5.staging" | translate }}</label>
					<span>{{ lastPickedLocation }}</span>
				</div>
				<div class="info-row">
					<label>{{ "h5.part" | translate }}</label>
					<span>{{ lastPickedPart }}</span>
				</div>
				<div class="info-row">
					<label>{{ "h5.quantity" | translate }}</label>
					<span>{{ lastPickedQuantity }}</span>
				</div>
			</div>
		</div>
	</div>
</div>

<alert-custom
	*ngIf="showAlert"
	(onCloseModal)="hideErrorModal($event)"
	[msg]="errorMessage"
	[elId]="errorFocus"
	[title]="errorTitle"
>
</alert-custom>

<p-dialog
	[(visible)]="shouldShowSerialNumberModal"
	[draggable]="false"
	[modal]="true"
	resizable="true"
	[closable]="false"
	[contentStyle]="{ overflow: 'visible' }"
	[style]="{ width: '350px' }"
	styleClass="custom-dialog"
>
	<ng-template pTemplate="header">{{ 'modal.insertSerialNumber' | translate }}</ng-template>

		<h1 class="serial-number-subtitle">{{ 'modal.fillSerialNumber' | translate }}</h1>
		<div>
			<div
				*ngFor="
					let serialNumber of serialNumbers;
					let i = index;
					trackBy: trackByIndex
				"
				class="serial-number--input"
			>
				<input
					type="text"
					pInputText
					tabindex="-1"
					id="serial-number-{{ i }}"
					maxlength="20"
					[style]="{ width: '100%' }"
					[(ngModel)]="serialNumbers[i]"
					(keydown.enter)="checkSerialNumber(i)"
					(blur)="checkSerialNumber(i)"
					(keypress)="allowOnlyAlphanumeric($event)"
					[autofocus]="i === 0"
				/>
				<div class="serial-number--error" *ngIf="serialNumberErrors[i]">
					<div>
						<i class="pi pi-times-circle" style="color: #994649"></i>
					</div>
					<span>{{ 'modal.serialNumberUsed' | translate }}</span>
				</div>
			</div>
		</div>
		<ng-template pTemplate="footer">
			<button
				class="submit"
				type="submit"
				pButton
				label="{{ 'modal.confirm' | translate }}"
				(click)="checkAllSerialNumbers()"
				[disabled]="!areAllSerialNumbersFilled() || hasSerialNumberErrors() || !areAllSerialNumbersValidated()"
			></button>
		</ng-template>
</p-dialog>

<input-generic
	[inputFields]="inputFields"
	tabindex="-1"
	(eventEmitter)="executeAction($event)"
>
</input-generic>

<p-toast position="top-center" key="tc"></p-toast>
